import { DeviceManagementConfigurationPolicy } from '@microsoft/microsoft-graph-types-beta';
import { getConfigurationPolicySettingsFromSchema } from '..';
import { getIntunePolicyAssignmentsFromSchema } from '../../helper';
import { DeviceConfigurationWindowsChromeBlockPasswordSavingSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/windows-chrome-block-password-saving/model';
import {
    createConfigurationPolicy,
    updateConfigurationPolicy,
} from 'projects/angular-clarity/src/app/stores/client/graph/intune/device-configuration-policies/actions';

export function Remediate(
    _tenant: string,
    data: DeviceManagementConfigurationPolicy[],
    schema: DeviceConfigurationWindowsChromeBlockPasswordSavingSchema,
) {
    const name = schema.contains.properties.name?.const;

    const currentPolicy = data.find((res) => res?.name === name);

    const policy: DeviceManagementConfigurationPolicy = {
        name: schema.contains.properties.name?.const,
        description: schema.contains.properties.description?.const,
        platforms: 'windows10',
        technologies: 'mdm',
        settings: getConfigurationPolicySettingsFromSchema(schema.contains.properties.settings),
    };

    if (currentPolicy?.id) {
        return updateConfigurationPolicy({
            _tenant,
            id: currentPolicy.id,
            policy,

            assignments: getIntunePolicyAssignmentsFromSchema(schema),
        });
    } else {
        return createConfigurationPolicy({
            _tenant,
            policy,
            assignments: getIntunePolicyAssignmentsFromSchema(schema),
        });
    }
}
